module.exports = {
    // basic
    'contact': 'contacto',
    'contacts': 'contactos',
    'phone': 'teléfono',
    'last-upload-date': 'última fecha de carga',
    'show-recent-used': 'Mostrar solo los usados ​​más recientemente',
    // raw
    'enter-contact-name': 'Por favor escriba el nombre de este contacto.',
    'confirm-delete-selected-contacts': `Los contactos seleccionados serán eliminados.  \r\n¿Continuar?`,

    // template
};
